// extracted by mini-css-extract-plugin
module.exports = {"container":"past-days-details_container__1Cv1-","temperature":"past-days-details_temperature__r8NqZ"};